import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';
import { CardSetTransformationService, CoreService, DataService, DialogService, FormConfigurationService, SaveDataRequest, SaveFormEvent, SpinnerService } from 'dspx-core';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AppDataService } from 'src/app/services/app-data.service';
import { take, finalize } from 'rxjs';
import { POP_UP_CODES, SERVER_ERROR_POP_UP_CODES, NAV_TAB_NUMBERS, PAGE_NUMBERS, PAGE_INDEX, SECTION_CODES, SECTION_INDEX, QUESTION_CODES, REFERENCE_DATA_IDS, SAVE_RESULT_STATUS } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { ErrorService } from 'src/app/services/error.service';
import { ConcessionsRebateCalculationRuleDetailsResponse } from 'src/app/interfaces/concessions-rebate-calculation-rule-details-response.interface';

@Component({
  selector: 'app-concessions-rebate-calculation-rule',
  templateUrl: './concessions-rebate-calculation-rule.component.html',
  styleUrl: './concessions-rebate-calculation-rule.component.scss'
})
export class ConcessionsRebateCalculationRuleComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.concessionsRebateCalculationRule;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  response: ConcessionsRebateCalculationRuleDetailsResponse;
  private exitRoutePrefix = '';
  private isPendingChangePreview: boolean;
  private viewInitiated = false;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private spinnerService: SpinnerService,
    private dataService: DataService,
    private errorService: ErrorService,
    private formConfigurationService: FormConfigurationService,
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    console.log(this.viewInitiated);
    document.addEventListener("DOMContentLoaded", (event) => {
      console.log("DOM fully loaded and parsed");
      console.log(this.viewInitiated);
    });

    this.coreService.applicationFunctions = {
      displayBtnSave: () => !this.isPendingChangePreview
    };
    // Visibility conditions
    this.coreService.conditionFunctions = {
      alwaysReadOnly: () => true,
      isPendingChangePreview: () => this.isPendingChangePreview,
      showRebateType: () => this.showRebateType(),
      showPaymentRuleTier: () => this.showPaymentRuleTier(),
      showMinThresholdAmount: () => this.showMinThresholdAmount(),
      showMaxThresholdAmount: () => this.showMaxThresholdAmount(),
      showAmount: () => this.showAmount(),
      showReason: () => this.showReason()
    }

    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const id = paramMap.get('id');
      if (id) {
        this.formServiceEndpoint = API_ENDPOINT_KEYS.getConcessionsRebateCalculationRuleConfigAndResponse;
        this.id = id;
      }
    });

    if (this.router.url.includes(ROUTE_CONSTANTS.concessionsApplicationRebateCalculationRule.prefixViewPending)) {
      this.exitRoutePrefix = ROUTE_CONSTANTS.concessionsApplicationRebateCalculationRule.list.rebateRulesPendingApproval;
      this.isPendingChangePreview = true;
    }
    else {
      this.exitRoutePrefix = ROUTE_CONSTANTS.concessionsApplicationRebateCalculationRule.list.rebateRulesApproved;
      this.isPendingChangePreview = false;
    }
  }

  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded($event: any): void {
    this.response = $event as ConcessionsRebateCalculationRuleDetailsResponse;
  }

  modelChanged(event: any): void {
  }

  filter(event: any): void {
  }

  buttonClicked(event: any): void {
  }

  save(event: SaveFormEvent) {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit
    }
    if (!event.isFormValid) {
      this.baseForm.markAllFieldsAsTouched();
      if (!this.baseForm.fields[0]?.formControl.valid) {
        this.baseForm.showValidationSummary(true);
        this.dialogService.showDialog(POP_UP_CODES.common.validationError);
      }
      else {
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  cancel(event: any) {
    this.exit();
  }

  dialogButton_saveSuccessful_Clicked(event: any): void {
    this.exit(true);
  }

  private exit(ignoreUnsavedChanges = false): void {
    this.navigate([this.exitRoutePrefix], ignoreUnsavedChanges);
  }

  private saveData(request: SaveDataRequest) {
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.dataService.saveData(API_ENDPOINTS.concessionsApplicationRebateCalculationRule.save, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            if (SERVER_ERROR_POP_UP_CODES.saveConcessionsRebateCalculationRules.includes(data.message)) {
              this.activeDialog = data.message;
            }
            else {
              this.id = data.id;
              this.activeDialog = POP_UP_CODES.common.saveSuccessful;
            }
            this.dialogService.showDialog(this.activeDialog);
          }
        })
    );
  }

  private getApplicationType(): string {
    if (this.baseForm?.model?.form?.tabs != null) {
      return this.formConfigurationService.getQuestionResponse(
        this.baseForm.model.form.tabs,
        'tab' + NAV_TAB_NUMBERS.concessionsRebateCalculationRuleForm.ruleDetails,
        'page' + PAGE_NUMBERS.concessionsRebateCalculationRuleForm.ruleDetails,
        PAGE_INDEX.noRepeater,
        SECTION_CODES.concessionsRebateCalculationRuleForm.rateDetails,
        SECTION_INDEX.noRepeater,
        QUESTION_CODES.concessionsRebateCalculationRuleForm.applicationType
      );
    }

    return null;
  }

  showRebateType(): boolean {
    const applicationType = this.getApplicationType();
    if (applicationType == null) {
      return false;
    }

    return applicationType == REFERENCE_DATA_IDS.applicationType.nonMainsLifeSupport;
  }

  showPaymentRuleTier() {
    const applicationType = this.getApplicationType();
    if (applicationType == null) {
      return false;
    }

    return !this.isNonMainsMedicalCoolingApplication(applicationType);
  }

  isNonMainsMedicalCoolingApplication(applicationType: any): boolean {
    return applicationType == REFERENCE_DATA_IDS.applicationType.nonMainsMedicalCooling;
  }

  showMinThresholdAmount() {
    const applicationType = this.getApplicationType();
    if (applicationType == null) {
      return false;
    }
    return this.showThresholdAmount(applicationType);
  }

  showMaxThresholdAmount() {
    const applicationType = this.getApplicationType();
    if (applicationType == null) {
      return false;
    }
    return this.showThresholdAmount(applicationType);
  }

  showThresholdAmount(applicationType: any): boolean {
    return applicationType == REFERENCE_DATA_IDS.applicationType.nonMainsWater
      || applicationType == REFERENCE_DATA_IDS.applicationType.nonMainsEnergy
  }

  private showAmount(): boolean {
    const applicationType = this.getApplicationType();
    // E.g. id="formly_139_input_paymentAmount_7-label"
    const paymentAmountElement = document.querySelector("[id*='input_paymentAmount']") as HTMLElement;

    switch (applicationType) {
      case REFERENCE_DATA_IDS.applicationType.nonMainsMedicalCooling:
        {
          if (paymentAmountElement != null) {
            paymentAmountElement.innerText = "% Amount *";
          }
          break;
        }
      case REFERENCE_DATA_IDS.applicationType.edapowGoldCardMunicipalRates:
      case REFERENCE_DATA_IDS.applicationType.nonMainsEnergy:
      case REFERENCE_DATA_IDS.applicationType.nonMainsLifeSupport:
      case REFERENCE_DATA_IDS.applicationType.nonMainsWater:
        {
          if (paymentAmountElement != null) {
            paymentAmountElement.innerText = "Payment Amount *";
          }
          break;
        }
    }
    return true;
  }

  showReason(): boolean {
    return this.response.paymentRuleStatusId == REFERENCE_DATA_IDS.concessionsApplicationRebateCalculationRuleStatus.approved;
  }
}
